import React from 'react'
import PropTypes from 'prop-types'
import DOMPurify from 'dompurify'
import { getLocalPath } from '../../utility'

const localPath = DOMPurify.sanitize(getLocalPath())

const expandContent = (e) => {
  e.preventDefault()
  e.target.closest('.Card-footer').classList.toggle('collapsed')
}

const FooterContent = ({ footerTitle, footerText, footerContentCollapsed }) => {
  return footerTitle && footerText ? (
    <div
      className={`Card-footer u-paddingHoriz4gu u-paddingBottom4gu ${
        footerContentCollapsed ? ' collapsed' : ''
      }`}
    >
      <hr className="u-textColorNeutral15" />
      <button
        type="button"
        className="u-textColorBrandLight u-textSecondary u-posRelative hover-underline-animation u-marginVert1gu"
        onClick={expandContent}
        data-analytics="fund-card-feature-fund-inner-button"
      >
        {footerTitle}

        <img
          className="u-alignTop u-marginLeft1gu u-rotate90"
          alt="chevron"
          src={DOMPurify.sanitize(
            `${localPath}/webfiles/latest/assets/cti/images/icon_chevron_brand_light.svg`
          )}
        />
      </button>
      <div
        className="u-textColorNeutral75 collapsible"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(footerText) }}
      ></div>
    </div>
  ) : null
}

FooterContent.propTypes = {
  footerTitle: PropTypes.string,
  footerText: PropTypes.string,
  footerContentCollapsed: PropTypes.bool,
}

export { FooterContent }
